import { TableRow, TableCell, Collapse, Box, Typography, Table, TableHead, TableBody, SxProps, Theme } from "@mui/material";
import { TableRowType, TableItem } from "../RopTable/RopTable";
import { EmptyTable } from "../../../modules/clients/components/EmptyState";

type RopCollapsibleHistoryTableProps = {
    open: string[];
    collapseIndex: number;
    collapsibleTableRow?: TableRowType[]
    collapsibleTableHeader: TableItem[]
    title?: string
    colSpan?: number
    historyTableCellSx?: SxProps<Theme>
    hover?: boolean
    saveCollapsable?: boolean;
    savedKey?: string;
}

export default function RopCollapsibleHistoryTable(props: RopCollapsibleHistoryTableProps) {
    const { open, collapseIndex, collapsibleTableRow, collapsibleTableHeader, title, colSpan, historyTableCellSx, hover, saveCollapsable, savedKey } = props;

    return (
        <TableRow>
            <TableCell style={{ padding: 0 }} colSpan={colSpan || 6}>
                <Collapse in={saveCollapsable ? open.includes(`${savedKey ? `${savedKey}` : `row${collapseIndex}`}`) : open.includes(`row${collapseIndex}`)} timeout="auto" unmountOnExit>
                    <Box sx={{ marginY: 1, maxHeight: "300px", overflowY: "auto" }}>
                        {title &&
                            <Typography sx={{ marginTop: "20px", marginBottom: "10px", fontSize: "16px", fontWeight: "bold" }} gutterBottom component="div">
                                {title}
                            </Typography>
                        }
                        <Table size="small" sx={{ width: "100%" }} aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    {collapsibleTableHeader.map((header, i) => (
                                        <TableCell align={header.align} key={i}>{header.item}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {collapsibleTableRow && collapsibleTableRow?.length > 0 ? collapsibleTableRow?.map((historyRow, rowIndex) => (
                                    <TableRow sx={{
                                        "&:last-child td, &:last-child th": { border: 0 },
                                        cursor: "pointer",
                                    }} hover={hover} key={rowIndex}>
                                        {historyRow.rowItems.map((item, i) => (
                                            <TableCell sx={{
                                                ...historyTableCellSx, borderBottom: (collapsibleTableRow.length - 1) == rowIndex ? "none" : "1px solid #515151", width: item.width,
                                                display: {
                                                    xs: item.isMobile ? "table-cell" : "none",
                                                    md: "table-cell",
                                                },
                                            }} align={item.align} key={i}>{item.item}</TableCell>
                                        ))}
                                    </TableRow>
                                )) : (
                                    <TableRow>
                                        <TableCell
                                            sx={{
                                                textAlign: "center",
                                                borderBottom: "none",
                                            }}
                                            align="center"
                                            colSpan={collapsibleTableHeader.length}>
                                            <EmptyTable />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    );
}